import RoleCustomer from './RoleCustomer'

export default RoleCustomer
